import { render } from "./LoginGetToken.vue?vue&type=template&id=68d3bac1"
import script from "./LoginGetToken.vue?vue&type=script&lang=js"
export * from "./LoginGetToken.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__